import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=450330c6&scoped=true&"
import script from "./UploadButton.vue?vue&type=script&lang=js&"
export * from "./UploadButton.vue?vue&type=script&lang=js&"
import style0 from "./UploadButton.vue?vue&type=style&index=0&id=450330c6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450330c6",
  null
  
)

/* custom blocks */
import block0 from "./UploadButton.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450330c6')) {
      api.createRecord('450330c6', component.options)
    } else {
      api.reload('450330c6', component.options)
    }
    module.hot.accept("./UploadButton.vue?vue&type=template&id=450330c6&scoped=true&", function () {
      api.rerender('450330c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Sensor/UploadButton.vue"
export default component.exports